<template>
  <div class="banner" :style="'background-image: url(' + tenantBanner + ')'">
    <div class="banner-overlay" v-if="tenant.data.showBannerOverlay">
      <div class="container">
        <div class="clearfix" v-if="tenant.data.subdomain">
          <div class="col23">
            <div class="logo" :style="'background-image: url(' + tenantLogoUrl(tenant.data) + ')'" />
            <div class="beside-logo">
              <h2>{{ tenant.data.name || tenant.subdomain }}</h2>
              <p>
                Office Phone Number{{ tenant.data.officePhone }}<br/>
                <!--
                Fax {{ tenant.data.fax }}<br/>
                -->
                https://{{ domain }}/<br/>
                <a :href="tenant.data.websiteUrl" target="_blank">{{ tenant.data.websiteUrl }}</a><br/>
              </p>
            </div>
          </div>
          <div class="col13" style="margin-top: 2rem; text-align: center;">
            <v-icon dark>place</v-icon> {{ tenant.data.address }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { tenantLogoUrl } from '../utils/PfxUtils.js'

  export default {
    name: 'FrontPageTenantBanner',
    props: {
      selectedTenant: {
        type: Object,
        required: false,
        default: () => { return undefined }
      }
    },
    data() {
      return {
        domain: window.location.host
      }
    },
    computed: {
      tenant() {
        if (this.selectedTenant && this.selectedTenant.data && this.selectedTenant.data.subdomain) return this.selectedTenant
        return this.$store.state.tenant
      },
      tenantBanner() {
        if ( this.tenant.data.banner === null ||  this.tenant.data.banner.key === 'null' || this.tenant.data.banner.key === '' ) {
          return require('../assets/landing-page-background.jpg')
        }
        return this.tenant.data.bannerUrl || require('../assets/landing-page-background.jpg')
      }
    },
    methods: {
      tenantLogoUrl
    }
  }
</script>

<style lang="scss" scoped>
  @import '../pfx.scss';

  .col13 { @include column(1/3); }
  .col23 { @include column(2/3); }

  .banner {
    margin: 0 0 2rem;
    background-position: center;
    background-size: cover;
    height: 20rem;
    min-height: 20rem;
    //border-bottom: 1em solid #df1900; // NOTE: defined the ThemeWrapper: brandColor
    color: $color-white;

    .banner-overlay {
      padding: 5rem 2rem 0;
      background-color: rgba(0, 0, 0, 0.75);
      height: 100%;
    }
  }

  .logo {
    height: 9rem;
    width: 9rem;
    float: left;
    //background-color: $color-pure-white;
    //border-radius: 50%;
    //background-size: 70%;
    background-size: cover;
    background-position: center;
  }
  .beside-logo {
    margin-left: 9rem;
    padding-left: 2rem;
    a {
      color: $color-white;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/FrontPageTenantBanner.vue